import { render, staticRenderFns } from "./Cmapa2.vue?vue&type=template&id=4b1bf74c&"
import script from "./Cmapa2.vue?vue&type=script&lang=js&"
export * from "./Cmapa2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports